const _env = {
    SERVICE_MAIN_PHX: process.env.REACT_APP_API_MAIN_ENDPOINT,
    SERVICE_MAIN_ENDPOINT_PUBLIC:
        process.env.REACT_APP_API_MAIN_ENDPOINT_PUBLIC,
    SERVICE_KEYCLOAK: process.env.REACT_APP_API_KEYCLOAK,
    KEYCLOAK_PATH: process.env.REACT_APP_KEYCLOAK_PATH,
    COOKIE_SCANNER_ENDPOINT: process.env.REACT_APP_API_COOKIE_SCANNER_ENDPOINT,
    SDK_BANNER_ENDPOINT: process.env.REACT_APP_API_SDKBANNER_ENDPOINT,
};

const environment = {
    production: true,

    //SDK BANNER
    API_SDK_BANNER: _env.SDK_BANNER_ENDPOINT,

    // au
    API_KEYCLOAK: _env.SERVICE_KEYCLOAK,
    API_KEYCLOAK_PATH: _env.KEYCLOAK_PATH,

    // ex
    API_LOGIN: _env.SERVICE_MAIN_PHX + '/user/login',
    API_FORGOT_PASSWORD: _env.SERVICE_MAIN_PHX + '/forgot/pwd',
    API_CHECK_TOKEN: _env.SERVICE_MAIN_PHX + '/check/link/',
    API_NEW_PASSWORD: _env.SERVICE_MAIN_PHX + '/user/new/pwd',
    API_CHANGE_PASSWORD: _env.SERVICE_MAIN_PHX + '/wfsecure/user/change/pwd',

    API_WFSECURE: _env.SERVICE_MAIN_PHX + '/wfsecure',
    API_PUBLIC: _env.SERVICE_MAIN_PHX + '/public-api',
    API_INTEGRATION: _env.SERVICE_MAIN_PHX + '/integration',

    // DataInventory
    API_BUSINESS_PROCESS: _env.SERVICE_MAIN_PHX + '/wfsecure/business-process',
    API_DEPARTMENT_LIST:
        _env.SERVICE_MAIN_PHX + '/wfsecure/department/dropdown',
    // Import Department
    API_IMPORT_DEPARTMENT:
        _env.SERVICE_MAIN_PHX + '/wfsecure/import-department',
    API_DATA_OWNER: _env.SERVICE_MAIN_PHX + '/wfsecure/data-owner',
    API_REVIEW_BY: _env.SERVICE_MAIN_PHX + '/wfsecure/reviewer',
    API_SEARCH_INVENTORY: _env.SERVICE_MAIN_PHX + '/wfsecure/data-inventory',
    API_CREATE_BUSINESS_PROCESS:
        _env.SERVICE_MAIN_PHX + '/wfsecure/business-process',
    API_ADD_INVENTORY: _env.SERVICE_MAIN_PHX + '/wfsecure/inventory',
    API_ADD_ACTIVITY_NAME: _env.SERVICE_MAIN_PHX + '/wfsecure/activity',
    API_EDIT_ACTIVITY_NAME: _env.SERVICE_MAIN_PHX + '/wfsecure/activity',
    API_ADD_ACTIVITY: _env.SERVICE_MAIN_PHX + '/wfsecure/activity',
    API_DATA_SUBJECT_RIGHT:
        _env.SERVICE_MAIN_PHX + '/wfsecure/m/subject-rights',
    API_DATA_CATEGORY: _env.SERVICE_MAIN_PHX + '/wfsecure/m/data-category',
    API_DATA_RISK: _env.SERVICE_MAIN_PHX + '/wfsecure/m/risk',
    API_DATA_SECRET: _env.SERVICE_MAIN_PHX + '/wfsecure/m/secret',
    API_DATA_DOCUMENT_TYPE: _env.SERVICE_MAIN_PHX + '/wfsecure/m/document-type',

    API_DATA_FLOW: _env.SERVICE_MAIN_PHX + '/wfsecure/activity/tab/data-flow',
    // User Management
    API_USER_SEARCH:
        _env.SERVICE_MAIN_PHX + '/wfsecure/user-manage/account-list',
    API_CHANGE_STATUS: _env.SERVICE_MAIN_PHX + '/wfsecure/user-manage/status',
    API_ROLES_USER: _env.SERVICE_MAIN_PHX + '/wfsecure/user-manage/m/roles',
    API_PERMISSION_USER:
        _env.SERVICE_MAIN_PHX + '/wfsecure/user/permission/list',
    API_ADD_USER: _env.SERVICE_MAIN_PHX + '/wfsecure/user-manage/account',
    API_COMPANY: _env.SERVICE_MAIN_PHX + '/wfsecure/user-manage/company',
    API_GET_USER_DETAIL:
        _env.SERVICE_MAIN_PHX + '/wfsecure/user-manage/account/',
    API_GET_DEPARTMENT_DETAIL: _env.SERVICE_MAIN_PHX + '/wfsecure/department/',
    API_SAVE_DEPARTMENT: _env.SERVICE_MAIN_PHX + '/wfsecure/department',
    API_DELETE_DEPARTMENT: _env.SERVICE_MAIN_PHX + '/wfsecure/department/',
    API_GET_MEMBER: _env.SERVICE_MAIN_PHX + '/wfsecure/users/dropdown',
    API_IMPORT_USER: _env.SERVICE_MAIN_PHX + '/wfsecure/import-user',
    API_USER_LIST: _env.SERVICE_MAIN_PHX + '/wfsecure/user-manage/admin/list',

    // Data Correlation
    API_SEARCH_ACTIVITY:
        _env.SERVICE_MAIN_PHX + '/wfsecure/data-correlation/activity',
    API_GET_META_DATA: _env.SERVICE_MAIN_PHX + '/wfsecure/metadata/dropdown',
    API_SEARCH_INQUIRY:
        _env.SERVICE_MAIN_PHX + '/wfsecure/data-correlation/inquiry',
    API_GET_APPLICATION:
        _env.SERVICE_MAIN_PHX +
        '/wfsecure/data-correlation/application/dropdown',
    API_SAVE_USER_DETAIL:
        _env.SERVICE_MAIN_PHX + '/wfsecure/user-manage/account',
    API_DEPARTMENT_SEARCH: _env.SERVICE_MAIN_PHX + '/wfsecure/department',
    API_LAWFUL_BASIS: _env.SERVICE_MAIN_PHX + '/wfsecure/lawfulbasis',

    // data correlation Detail
    API_DATA_CORRELATION: _env.SERVICE_MAIN_PHX + '/wfsecure/data-correlation',
    API_METADATA: _env.SERVICE_MAIN_PHX + '/wfsecure/metadata',
    API_CONTRACT: _env.SERVICE_MAIN_PHX + '/wfsecure/contract',
    API_CONTRACT_DROPDOWN:
        _env.SERVICE_MAIN_PHX + '/wfsecure/contract/dropdown',
    API_TYPE_DROPDOWN:
        _env.SERVICE_MAIN_PHX + '/wfsecure/consent/type/dropdown',
    API_PURPOSE_DROPDOWN: _env.SERVICE_MAIN_PHX + '/wfsecure/purpose/dropdown',
    API_CONTRACT_SEARCH: _env.SERVICE_MAIN_PHX + '/wfsecure/contract',
    API_CONSENT_DETAIL:
        _env.SERVICE_MAIN_PHX + '/wfsecure/data-correlation/consent/',

    // DS Requset
    API_SEARCH_REQUEST: _env.SERVICE_MAIN_PHX + '/wfsecure/ds-request',
    API_REQUEST_DETAIL:
        _env.SERVICE_MAIN_PHX + '/wfsecure/data-subject/request-info',
    API_REQUEST_ACTIVITY:
        _env.SERVICE_MAIN_PHX + '/wfsecure/data-subject/activity',
    API_REQUEST_ACTIVITY_DETAIL:
        _env.SERVICE_MAIN_PHX + '/wfsecure/ds-request/activity',

    //RoPa
    API_ACTIVITY_DROPDOWN:
        _env.SERVICE_MAIN_PHX + '/wfsecure/m/activity/dropdown',
    API_BUSINESS_DROPDOWN:
        _env.SERVICE_MAIN_PHX + '/wfsecure/m/business/dropdown',
    API_SEARCH_ROPA: _env.SERVICE_MAIN_PHX + '/wfsecure/ropa',
    API_EXPORT_ZIP_PDF_ROPA: _env.SERVICE_MAIN_PHX + '/wfsecure/ropa/zip/pdf',
    API_EXPORT_EXCEL_ROPA: _env.SERVICE_MAIN_PHX + '/wfsecure/ropa/excel',
    API_EXPORT_PDF_ROPA: _env.SERVICE_MAIN_PHX + '/wfsecure/ropa/pdf',

    API_UPLOAD_DOC: _env.SERVICE_MAIN_PHX + '/wfsecure/doc',
    API_UPLOAD_FILE: _env.SERVICE_MAIN_PHX + '/wfsecure/file',
    API_PUBLIC_UPLOAD_DOC: _env.SERVICE_MAIN_PHX + '/public-api/doc',
    API_UPLOAD_IMAGE: _env.SERVICE_MAIN_PHX + '/wfsecure/image',
    API_PUBLIC_UPLOAD_IMAGE: _env.SERVICE_MAIN_PHX + '/public-api/image',
    API_PUBLIC_UPLOAD_FILE: _env.SERVICE_MAIN_PHX + '/public-api/file',
    API_UPLOAD_IMAGE_NOT_SECURE: _env.SERVICE_MAIN_PHX + '/image',
    API_CUSTOMER_ROLE: _env.SERVICE_MAIN_PHX + '/wfsecure/m/customer-role',
    API_REQUEST_TYPE: _env.SERVICE_MAIN_PHX + '/wfsecure/m/request-type',

    // DS KYC
    API_SEARCH_KYC: _env.SERVICE_MAIN_PHX + '/wfsecure/searchkyc',
    API_KYC: _env.SERVICE_MAIN_PHX + '/kyc',

    // Detail

    // Policy
    API_GET_POLICY: _env.SERVICE_MAIN_PHX + '/wfsecure/privacy-policy',
    API_PERSONAL_DATA_OPTION: _env.SERVICE_MAIN_PHX + '/m/personal-data-option',
    API_SENSITIVE_PERSONAL_DATA_OPTION:
        _env.SERVICE_MAIN_PHX + '/m/sensitive-data-option',
    API_GET_POLICY_CATEGORY:
        _env.SERVICE_MAIN_PHX + '/wfsecure/privacy-policy/category',
    API_GET_POLICY_HTML:
        _env.SERVICE_MAIN_PHX + '/wfsecure/privacy-policy/privacy-notice/html',
    API_GET_POLICY_PRIVACY_NOTICE:
        _env.SERVICE_MAIN_PHX + '/wfsecure/privacy-policy/privacy-notice',
    API_GET_POLICY_PRIVACY_NOTICE_NO_WFSECURE:
        _env.SERVICE_MAIN_PHX + '/privacy-policy/privacy-notice',
    API_GET_FREE_FORM: _env.SERVICE_MAIN_PHX + '/wfsecure/free-form-policy',
    // Dataflow
    API_GET_STATUS:
        _env.SERVICE_MAIN_PHX + '/wfsecure/inventory/data-flow/m/status',
    API_GET_DATA_SUBJECT:
        _env.SERVICE_MAIN_PHX + '/wfsecure/inventory/data-flow/m/data-subject',
    API_GET_AMOUNT_DATA_YEAR:
        _env.SERVICE_MAIN_PHX +
        '/wfsecure/inventory/data-flow/m/amount-data-year',
    API_GET_LAWFULLBASIS: _env.SERVICE_MAIN_PHX + '/wfsecure/m/lawfulbasis',
    API_SEND_TAB_1:
        _env.SERVICE_MAIN_PHX + '/wfsecure/inventory/data-flow/collect-data',
    API_SEARCH_DATAFLOW_LIST:
        _env.SERVICE_MAIN_PHX + '/wfsecure/inventory/data-flow',
    API_DELETE_DATAFLOW:
        _env.SERVICE_MAIN_PHX + '/wfsecure/inventory/data-flow/',
    API_DELETE_ACTIVITY: _env.SERVICE_MAIN_PHX + '/wfsecure/activity/',
    API_INVENTORY_DATAFLOW:
        _env.SERVICE_MAIN_PHX + '/wfsecure/inventory/data-flow',
    API_GET_INVENTORY_DATAFLOW:
        _env.SERVICE_MAIN_PHX + '/wfsecure/inventory/data-flow',
    API_GET_INVENTORY_DATAFLOW_DATA_SUBJECT:
        _env.SERVICE_MAIN_PHX + '/wfsecure/inventory/data-flow/data-subject',
    API_GET_REQUEST_REVISE:
        _env.SERVICE_MAIN_PHX + '/wfsecure/inventory/data-flow/request-revise',
    API_EXPORT_DATAFLOW: _env.SERVICE_MAIN_PHX + '/wfsecure/dataflow/export',

    // Ropa
    API_INVENTORY_ROPA: _env.SERVICE_MAIN_PHX + '/wfsecure/inventory/ropa',
    API_SECRET: _env.SERVICE_MAIN_PHX + '/wfsecure/m/secret',

    // Activity
    API_INVENTORY_ACTIVITY:
        _env.SERVICE_MAIN_PHX + '/wfsecure/inventory/activity',
    API_GET_ACTIVITY_LIST: _env.SERVICE_MAIN_PHX + '/wfsecure/activity/',

    // ROPA
    API_ROPA: _env.SERVICE_MAIN_PHX + '/wfsecure/ropa',
    API_ROPA_MASTER: _env.SERVICE_MAIN_PHX + '/wfsecure/ropa/activity/m',
    API_ROPA_TEMPLATE_MASTER: _env.SERVICE_MAIN_PHX + '/wfsecure/m/template',

    // Risk Assessment
    API_RISK_ASSESSMENT: _env.SERVICE_MAIN_PHX + '/wfsecure/risk-assessment',
    API_PUBLISH_RISK_ASSESSMENT:
        _env.SERVICE_MAIN_PHX + '/wfsecure/risk-assessment/publish-version',

    API_SEARCH_RISK_ASSESSMENT:
        _env.SERVICE_MAIN_PHX + '/wfsecure/risk-assessment/ropa',
    API_SEARCH_RISK_ASSESSMENT_REGISTER:
        _env.SERVICE_MAIN_PHX + '/wfsecure/risk-assessment/registered',
    API_HEADER_RISK_ASSESSMENT:
        _env.SERVICE_MAIN_PHX + '/wfsecure/risk-assessment/header',

    // DC & DPO
    API_DC_DPO: _env.SERVICE_MAIN_PHX + '/wfsecure/dc-dpo',

    // Risk Register
    API_RISK_REGISTER: _env.SERVICE_MAIN_PHX + '/wfsecure/risk-register',
    API_STATUS: _env.SERVICE_MAIN_PHX + '/wfsecure/m/status',

    // Data Catalog
    API_DATAHUB_URL: _env.SERVICE_MAIN_PHX + '/wfsecure/datahub/url',
    API_DATA_CATALOG: _env.SERVICE_MAIN_PHX + '/wfsecure/datahub/data-catalog',
    API_DROPDOWN_DATA_CATALOG:
        _env.SERVICE_MAIN_PHX + '/wfsecure/datahub/m/data-catalog',

    API_DATA_HUB_PLATFORM:
        _env.SERVICE_MAIN_PHX + '/wfsecure/datahub/m/platform',
    API_DATA_HUB_DB: _env.SERVICE_MAIN_PHX + '/wfsecure/datahub/m/db',
    API_MY_COMPANY: _env.SERVICE_MAIN_PHX + '/wfsecure/company',

    // cookie scanner
    API_COOKIE_SCANNER_ENDPOINT: _env.COOKIE_SCANNER_ENDPOINT,
    API_COOKIE_SCANNER: _env.SERVICE_MAIN_PHX + '/wfsecure',

    // DS Request Form
    API_NOSECURE_DS_REQUEST_FORM: _env.SERVICE_MAIN_PHX + '/ds-request-form',
    API_DS_REQUEST_FORM: _env.SERVICE_MAIN_PHX + '/wfsecure/ds-request-form',
    API_MASTER_DS_REQUEST_FORM: _env.SERVICE_MAIN_PHX + '/m/ds-request-form',
    API_DS: _env.SERVICE_MAIN_PHX + '/wfsecure/m/data-subject',
    API_PUBLIC_DS_REQUEST_FORM:
        _env.SERVICE_MAIN_PHX + '/public-api/ds-request-form',
    API_PUBLIC_REQUEST_TYPE:
        _env.SERVICE_MAIN_PHX + '/public-api/m/request-type',
    API_CHECK_WORKFLOW_STEP:
        _env.SERVICE_MAIN_PHX + '/wfsecure/check/work-flow/step',
    //Cookie Banner
    API_COOKIE_MANAGEMENT:
        _env.SERVICE_MAIN_PHX + '/wfsecure/cookie-management',
    API_SETTING_PREFERENCE:
        _env.SERVICE_MAIN_PHX + '/wfsecure/setting-preference',

    // workflow
    API_WORKFLOW: _env.SERVICE_MAIN_PHX + '/wfsecure/workflow',
    API_WORKFLOW_M_DS_TYPE:
        _env.SERVICE_MAIN_PHX + '/wfsecure/m/workflow/ds-type',
    API_WORKFLOW_M_STATE: _env.SERVICE_MAIN_PHX + '/wfsecure/m/workflow/state',
    API_DEPARTMENT_ALL: _env.SERVICE_MAIN_PHX + '/wfsecure/department/all',

    // My task
    API_MY_TASK: _env.SERVICE_MAIN_PHX + '/wfsecure/my-task',
    API_KYC_MY_TASK: _env.SERVICE_MAIN_PHX + '/wfsecure/kyc',
    API_DOMAIN: _env.SERVICE_MAIN_PHX + '/wfsecure/domain/owner',
    // DS My Task
    API_SEARCH_MY_TASK: _env.SERVICE_MAIN_PHX + '/wfsecure/task',

    // Consent
    API_CONSENT: _env.SERVICE_MAIN_PHX + '/wfsecure/consent',
    API_CONSENT_LOG: _env.SERVICE_MAIN_PHX + '/wfsecure/consent-log',
    // DS 360
    API_DS_360: _env.SERVICE_MAIN_PHX + '/wfsecure/data-subject-360',

    //Cookie Category
    API_COOKIE_CATEGORY: _env.SERVICE_MAIN_PHX + '/wfsecure/cookie-category',
    API_COOKIE: _env.SERVICE_MAIN_PHX + '/wfsecure/cookie',

    // Manage Consent
    API_MANAGE_CONSENT: _env.SERVICE_MAIN_PHX + '/wfsecure/manage-consent',

    // Template Design
    API_TEMPLATE_DESIGN: _env.SERVICE_MAIN_PHX + '/wfsecure/template-design',
    API_MASTGER_TEMPLATE_DESIGN:
        _env.SERVICE_MAIN_PHX + '/wfsecure/m/template-design',
    API_CONSENT_PUBLISHED: _env.SERVICE_MAIN_PHX + '/wfsecure/consent/publish',
    API_TEMPLATE_DESIGN_CONSENT:
        _env.SERVICE_MAIN_PHX + '/wfsecure/template-design/consent',
    API_TEMPLATE_DESIGN_TERM_AND_CONDITION:
        _env.SERVICE_MAIN_PHX + '/wfsecure/template-design/term-condition',
    API_TEMPLATE_DESIGN_CONSENT_NO_SECURE:
        _env.SERVICE_MAIN_PHX + '/public-api/template-design/consent',
    API_TEMPLATE_DESIGN_TERM_AND_CONDITION_NO_SECURE:
        _env.SERVICE_MAIN_PHX + '/public-api/template-design/term-condition',

    // Import Consent
    API_IMPORT_CONSENT: _env.SERVICE_MAIN_PHX + '/wfsecure/import-consent',
    // Import DS Request
    API_IMPORT_DS_REQUEST:
        _env.SERVICE_MAIN_PHX + '/wfsecure/import-ds-request',
    // HR Privacy Policy
    API_HR_PRIVACY_POLICY:
        _env.SERVICE_MAIN_PHX + '/wfsecure/hr-privacy-policy',
    API_HR_PRIVACY_POLICY_PUBLIC:
        _env.SERVICE_MAIN_PHX + '/public-api/hr-privacy-policy',

    // Recruitment Privacy Policy
    API_RECRUITMENT_PRIVACY_POLICY:
        _env.SERVICE_MAIN_PHX + '/wfsecure/recruitment-privacy-policy',
    API_RECRUITMENT_PRIVACY_POLICY_PUBLIC:
        _env.SERVICE_MAIN_PHX + '/public-api/recruitment-privacy-policy',

    // VENDOR Privacy Policy
    API_VENDOR_PRIVACY_POLICY:
        _env.SERVICE_MAIN_PHX + '/wfsecure/vendor-privacy-policy',
    API_VENDOR_PRIVACY_POLICY_PUBLIC:
        _env.SERVICE_MAIN_PHX + '/public-api/vendor-privacy-policy',

    // Cookie Policy
    API_COOKIE_PRIVACY_POLICY:
        _env.SERVICE_MAIN_PHX + '/wfsecure/cookie-policy',
    API_COOKIE_PRIVACY_POLICY_PUBLIC:
        _env.SERVICE_MAIN_PHX + '/public-api/cookie-policy',

    // CCTV Policy
    API_CCTV_POLICY: _env.SERVICE_MAIN_PHX + '/wfsecure/cctv-policy',
    API_CCTV_POLICY_PUBLIC: _env.SERVICE_MAIN_PHX + '/public-api/cctv-policy',

    // Free form Policy
    API_FREE_FORM_POLICY: _env.SERVICE_MAIN_PHX + '/wfsecure/free-from-policy',
    API_FREE_FORM_POLICY_PUBLIC:
        _env.SERVICE_MAIN_PHX + '/public-api/free-from-policy',

    // DPA
    API_DPA_POLICY: _env.SERVICE_MAIN_PHX + '/wfsecure/dpa-policy',
    API_DPA_POLICY_PUBLIC: _env.SERVICE_MAIN_PHX + '/public-api/dpa-policy',
    // Admin
    API_ORGANIZE_ADMIN: _env.SERVICE_MAIN_PHX + '/wfsecure/organize/admin',
    // DPIA
    API_DPIA: _env.SERVICE_MAIN_PHX + '/wfsecure/dpia',
    API_DPIA_DATAFLOW: _env.SERVICE_MAIN_PHX + '/wfsecure/dataflow-dpia',
    API_DPIA_IDENTIFICATION:
        _env.SERVICE_MAIN_PHX + '/wfsecure/dpia-identification',
    API_DPIA_IMPACT: _env.SERVICE_MAIN_PHX + '/wfsecure/dpia-impact-organize',
    API_DPIA_MEASURES:
        _env.SERVICE_MAIN_PHX + '/wfsecure/dpia-measures-organize',
    API_OTP_BY_EMAIL:
        _env.SERVICE_MAIN_ENDPOINT_PUBLIC + '/public-api/otp/email',
    // Verify OTP
    API_VERIFY_OTP:
        _env.SERVICE_MAIN_ENDPOINT_PUBLIC + '/public-api/otp/verify',
    // Email Setting
    API_EMAIL_SETTING: _env.SERVICE_MAIN_PHX + '/wfsecure/email/customize',
    // Ds Inquiry
    API_DS_INQUIRY: _env.SERVICE_MAIN_PHX + '/wfsecure/ds-inquiry',
    // Domain workflow verification
    API_DOMAIN_WORKFLOW_VERIFICATION:
        _env.SERVICE_MAIN_PHX + '/wfsecure/work-flow/verification',
    // Data flow summary
    API_GET_SUMMARY: _env.SERVICE_MAIN_PHX + '/wfsecure/dataflow/summary',
    // Data flow
    API_GET_DATA_FLOW: _env.SERVICE_MAIN_PHX + '/wfsecure/dataflow',
    // Comment disk-space
    API_COMMENT_DISK_SPACE:
        _env.SERVICE_MAIN_PHX + '/wfsecure/disk-space/comment',
    // Data Breach
    API_DATA_BREACH: _env.SERVICE_MAIN_PHX + '/wfsecure/data-breach',
    API_DATA_BREACH_RESPONSIBILITY:
        _env.SERVICE_MAIN_PHX + '/wfsecure/data-breach-permission',
    API_DATA_BREACH_PUBLIC: _env.SERVICE_MAIN_PHX + '/public-api/data-breach',
    // Permission
    API_PERMISSION: _env.SERVICE_MAIN_PHX + '/wfsecure/permission',
    API_USER_PERMISSION: _env.SERVICE_MAIN_PHX + '/wfsecure/user/permission',
    // Release
    API_RELEASE: _env.SERVICE_MAIN_PHX + '/wfsecure/release',

};

export default environment;
